<div class="spinner-container flex flex-column align-items-center justify-content-center h-screen w-screen">
  <img [src]="environment.frontEndUrl + '/assets/images/login.gif'" alt="loggo" style="width: 550px; height: auto" />

  @if (showLogout()) {
    <div class="logout-section" (click)="logout()">
      <i class="pi pi-sign-out icon"></i>
      {{ "HEADER.LOGOUT" | translate }}
    </div>
  }
</div>
